import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
   selector: 'app-upload-dialog',
   templateUrl: './upload-dialog.component.html'
})
export class UploadDialogComponent {
   selectedFile: File | null = null;

   constructor(public dialogRef: MatDialogRef<UploadDialogComponent>) {}

   onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
      if (!input.files || input.files.length === 0) return;

      const file = input.files[0];
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
         alert('Csak .xlsx fájl engedélyezett!');
         return;
      }

      this.selectedFile = file;
   }

   upload() {
      this.dialogRef.close(this.selectedFile);
   }

   reset() {
      this.selectedFile = null;
   }

   close() {
      this.dialogRef.close(null);
   }
}
